import React from 'react';
import { Mail, Phone, MapPin, Clock, Award } from 'lucide-react';

export const About = () => {
  return (
    <div className="min-h-screen bg-brand-cream pt-24 pb-16 fade-in" data-testid="about-page">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="uppercase tracking-[0.2em] text-xs font-bold text-brand-gold mb-4">
            About Us
          </p>
          <h1 className="font-heading text-5xl sm:text-6xl font-light tracking-tight text-brand-green-dark mb-6">
            Farm-Fresh Excellence,
            <br />
            <span className="italic text-brand-green">Delivered with Care</span>
          </h1>
        </div>

        <div className="mb-16 p-12 rounded-sm lily-story-bg">
          <div className="max-w-3xl mx-auto">
            <p className="font-body text-base sm:text-lg leading-relaxed font-light text-brand-cream mb-6">
              FarmFreshLily is Hyderabad's premier destination for A-grade oriental lilies.
              We cultivate each stem with meticulous care on our local farms, ensuring every lily
              reaches you at peak bloom with its signature beautiful aroma.
            </p>
            <p className="font-body text-base sm:text-lg leading-relaxed font-light text-brand-cream">
              Our lilies are expertly cut and ready for a beautiful vase or evening gathering.
              With delivery within 2 business days across Hyderabad, we bring luxury and elegance
              straight to your door.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="bg-brand-blush/25 gold-border-glow p-8 rounded-sm text-center">
            <Award className="w-12 h-12 text-brand-gold mx-auto mb-4" strokeWidth={1.5} />
            <h3 className="font-heading text-xl font-light text-brand-green-dark mb-3">
              A-Grade Quality
            </h3>
            <p className="font-body text-sm text-brand-green-dark/70 leading-relaxed">
              Every lily is handpicked at peak bloom and meets our rigorous A-grade standards for freshness and beauty.
            </p>
          </div>

          <div className="bg-brand-sage/25 gold-border-glow p-8 rounded-sm text-center">
            <Clock className="w-12 h-12 text-brand-gold mx-auto mb-4" strokeWidth={1.5} />
            <h3 className="font-heading text-xl font-light text-brand-green-dark mb-3">
              Fast Delivery
            </h3>
            <p className="font-body text-sm text-brand-green-dark/70 leading-relaxed">
              Orders placed before 2 PM are delivered within 2 business days across Hyderabad. Fresh and on time, always.
            </p>
          </div>

          <div className="bg-brand-blush/25 gold-border-glow p-8 rounded-sm text-center">
            <MapPin className="w-12 h-12 text-brand-gold mx-auto mb-4" strokeWidth={1.5} />
            <h3 className="font-heading text-xl font-light text-brand-green-dark mb-3">
              Hyderabad Local
            </h3>
            <p className="font-body text-sm text-brand-green-dark/70 leading-relaxed">
              Proudly serving Hyderabad with farm-fresh oriental lilies grown and delivered with love and dedication.
            </p>
          </div>
        </div>

        <div className="bg-brand-green p-12 rounded-sm">
          <h2 className="font-heading text-3xl font-light text-brand-cream text-center mb-8">
            Get in Touch
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="flex items-start gap-4">
              <Phone className="w-5 h-5 text-brand-gold flex-shrink-0 mt-1" strokeWidth={1.5} />
              <div>
                <p className="font-body text-sm text-brand-cream/70 mb-1">Phone</p>
                <p className="font-body text-brand-cream">+91 98765 43210</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <Mail className="w-5 h-5 text-brand-gold flex-shrink-0 mt-1" strokeWidth={1.5} />
              <div>
                <p className="font-body text-sm text-brand-cream/70 mb-1">Email</p>
                <p className="font-body text-brand-cream">hello@farmfreshlily.com</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <MapPin className="w-5 h-5 text-brand-gold flex-shrink-0 mt-1" strokeWidth={1.5} />
              <div>
                <p className="font-body text-sm text-brand-cream/70 mb-1">Location</p>
                <p className="font-body text-brand-cream">Hyderabad, Telangana</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
